<template>
  <div v-if="officialPage" class="official-shell">
    <iframe
      :key="officialPage"
      class="official-frame"
      :src="officialPage"
      :title="officialTitle"
      :style="officialFrameStyle"
      @load="hideContactSection"
    ></iframe>
  </div>

  <div v-else class="website-layout">
    <WebsiteHeader />
    <main class="website-content">
      <router-view />
    </main>
    <WebsiteFooter v-if="!hideFooter" />
  </div>
</template>

<script>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import WebsiteHeader from '@/components/WebsiteHeader.vue'
import WebsiteFooter from '@/components/WebsiteFooter.vue'

const OFFICIAL_PAGES = {
  Home: '/official/index.html',
  About: '/official/gywm.html',
  Services: '/official/fwjs.html',
  News: '/official/xwzx.html'
}

export default {
  name: 'WebsiteLayout',
  components: {
    WebsiteHeader,
    WebsiteFooter
  },
  setup() {
    const route = useRoute()
    const isNarrowScreen = ref(false)
    const viewportWidth = ref(1200)
    const viewportHeight = ref(800)
    const updateViewport = () => {
      viewportWidth.value = window.innerWidth
      viewportHeight.value = window.innerHeight
      isNarrowScreen.value = window.innerWidth < 1200
    }
    onMounted(() => {
      updateViewport()
      window.addEventListener('resize', updateViewport, { passive: true })
    })
    onBeforeUnmount(() => window.removeEventListener('resize', updateViewport))

    const officialPage = computed(() => OFFICIAL_PAGES[route.name] || '')
    const officialFrameStyle = computed(() => {
      if (!isNarrowScreen.value) return undefined
      const scale = viewportWidth.value / 1200
      return {
        width: '1200px',
        height: `${viewportHeight.value / scale}px`,
        transform: `scale(${scale})`,
        transformOrigin: 'top left'
      }
    })
    const officialTitle = computed(() => route.meta.title || '国测检测')
    const hideFooter = computed(() => route.name === 'VerificationDetail' && isNarrowScreen.value)
    const hideContactSection = (event) => {
      const frameDocument = event.target.contentDocument
      if (!frameDocument || frameDocument.getElementById('gc-contact-override')) return
      const style = frameDocument.createElement('style')
      style.id = 'gc-contact-override'
      style.textContent = `
        .w-nav > .w-nav-inner { width: 20% !important; }
        #smv_tem_21_7 { display: none !important; }
        .icp-area { display: none !important; }
      `
      frameDocument.head.appendChild(style)
      const routeLinks = {
        'index.html': '/',
        'sy.html': '/',
        'gywm.html': '/about',
        'fwjs.html': '/services',
        'xwzx.html': '/news'
      }
      frameDocument.querySelectorAll('.w-nav-item-link').forEach((link) => {
        const originalHref = link.getAttribute('href')
        if (routeLinks[originalHref]) {
          link.href = routeLinks[originalHref]
          link.target = '_top'
        }
      })
      frameDocument.querySelectorAll('a[href="lxwm.html"]').forEach((link) => {
        link.href = '/verification'
        link.target = '_top'
        const text = link.querySelector('.w-link-txt')
        if (text) text.textContent = '报告查真伪'
      })
      frameDocument.querySelectorAll('.company-info-title').forEach((element) => {
        element.textContent = element.textContent
          .replace(/\s*备案号[:：]?\s*鲁ICP备14020647号-1/g, '')
          .replace(/鲁ICP备14020647号-1/g, '')
      })
    }

    return {
      officialPage,
      officialFrameStyle,
      officialTitle,
      hideContactSection,
      hideFooter
    }
  }
}
</script>

<style scoped>
.official-shell {
  width: 100%;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  background: #fff;
}

.official-frame {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}

.website-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.website-content {
  flex: 1;
}
</style>
